import PieHighchart from './PieHighchart'
import ColumnHighchart from './ColumnHighchart'
import Highcharts from "highcharts"


class Highchart {
  constructor(chart) {
    this.chart = chart
    this.dataset = chart.dataset
    this.config = JSON.parse(this.dataset.highchart ?? '{}');
    this.chartList = this.config.chartList ? document.getElementById(this.config.chartList) : null

    Highcharts.setOptions({
      lang: {
        thousandsSep: `’`,
        decimalPoint: `.`
      }
    })

    switch (this.config.type) {
      case 'pie':
        new PieHighchart(this)
        break;
      case 'column':
        new ColumnHighchart(this)
        break;
      default:
        break;
        console.log('Not implemented yet');

    }

  }
}

export default Highchart
